import translations from './translations';

function getLanguageCode() {
    try {
        const user = JSON.parse(localStorage.getItem('kaixo_user'));
        if (user?.language) {
            const langMap = {
                'español': 'es', 'inglés': 'en', 'francés': 'fr', 'alemán': 'de',
                'portugués': 'pt', 'italiano': 'it', 'euskera': 'eu', 'chino': 'zh',
                'japonés': 'ja', 'árabe': 'ar', 'hindi': 'hi', 'ruso': 'ru',
                'coreano': 'ko', 'turco': 'tr', 'indonesio': 'id',
                'english': 'en', 'spanish': 'es', 'french': 'fr', 'german': 'de',
                'portuguese': 'pt', 'italian': 'it', 'basque': 'eu', 'chinese': 'zh',
                'japanese': 'ja', 'arabic': 'ar', 'russian': 'ru', 'korean': 'ko',
                'turkish': 'tr', 'indonesian': 'id'
            };
            const code = langMap[user.language.toLowerCase()];
            if (code && translations[code]) return code;
        }
    } catch (e) {}
    const lang = navigator.language || 'en';
    const code = lang.split('-')[0].toLowerCase();
    return translations[code] ? code : 'en';
}

export function getTranslations() {
    return translations[getLanguageCode()] || translations['en'];
}

export function getTranslationsForUser(user) {
    if (!user?.language) return translations['en'];
    const langMap = {
        'español': 'es', 'inglés': 'en', 'francés': 'fr', 'alemán': 'de',
        'portugués': 'pt', 'italiano': 'it', 'euskera': 'eu', 'chino': 'zh',
        'japonés': 'ja', 'árabe': 'ar', 'hindi': 'hi', 'ruso': 'ru',
        'coreano': 'ko', 'turco': 'tr', 'indonesio': 'id',
        'english': 'en', 'spanish': 'es', 'french': 'fr', 'german': 'de',
        'portuguese': 'pt', 'italian': 'it', 'basque': 'eu', 'chinese': 'zh',
        'japanese': 'ja', 'arabic': 'ar', 'russian': 'ru', 'korean': 'ko',
        'turkish': 'tr', 'indonesian': 'id'
    };
    const code = langMap[user.language.toLowerCase()] || 'en';
    return translations[code] || translations['en'];
}

// Proxy reactivo: cada acceso relee el idioma actual del usuario.
// Así cuando un usuario con idioma distinto inicia sesión, la UI se actualiza
// sin necesidad de recargar los módulos.
// Proxy recursivo: cada acceso (incluyendo sub-claves) relee el idioma actual.
function makeProxy(pathParts) {
    return new Proxy(function () {}, {
        get(_target, key) {
            if (typeof key === 'symbol') return undefined;
            const fullPath = [...pathParts, key];
            // Resolver en el momento del acceso: idioma actual + fallback en
            const resolve = (dict) => {
                let node = dict;
                for (const p of fullPath) {
                    if (node == null) return undefined;
                    node = node[p];
                }
                return node;
            };
            const current = getTranslations();
            const resolvedCurrent = resolve(current);
            const resolvedFallback = resolve(translations['en'] || {});
            const value = resolvedCurrent !== undefined ? resolvedCurrent : resolvedFallback;
            // Si es un objeto sigue navegando con otro proxy
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                return makeProxy(fullPath);
            }
            return value;
        }
    });
}

const t = makeProxy([]);
export default t;